import { Command, CommandResult } from '../procedure.interface';
import { Device } from '@/device';
import { EyesoftProperties, InstallProperties, KrysProperties } from '@/interfaces/properties.interface';
import { Logger } from '@/logger';
import { AdbSync, encodeUtf8 } from '@yume-chan/adb';
import { ReadableStream } from '@yume-chan/stream-extra';

export class WriteInstallFileCommand implements Command {
  public stopOnError: boolean;
  public type: string;
  public location: string;

  constructor(location: string) {
    this.stopOnError = true;
    this.type = 'writeInstallFile';
    this.location = location;
  }

  public toLog(): string {
    return 'Writing install file';
  }

  public async execute(device: Device, _logger: Logger, properties?: InstallProperties): Promise<CommandResult> {
    if (!device.adb) {
      return Promise.resolve({
        success: false,
        message: 'Not connected',
      });
    }

    if (!properties) {
      return Promise.resolve({
        success: false,
        message: 'Order not found',
      });
    }

    let content = {};

    if (properties?.procedure === 'CDL' || properties?.procedure === 'Krys') {
      const krysProperties = properties.properties as KrysProperties;
      content = {
        ssid: krysProperties.krys_wifi_ssid,
        password: krysProperties.krys_wifi_password,
        praticienCode: krysProperties.krys_client_code,
      };
    } else if (properties?.procedure !== 'Oculera') {
      const eyesoftProperties = properties.properties as EyesoftProperties;
      content = {
        praticienCode: eyesoftProperties.eyesoft_client_code,
      };
    }

    const path = `${this.location}/eyesoft_install.conf`;

    const file = new ReadableStream<Uint8Array>({
      start(controller) {
        controller.enqueue(encodeUtf8(JSON.stringify(content)));
        controller.close();
      },
    });

    // Write file
    try {
      const sync: AdbSync = await device.adb.sync();
      await sync.write({
        filename: path,
        file,
      });
      await sync.dispose();
    } catch (error: unknown) {
      return Promise.resolve({
        success: false,
        message: (error as Error).message,
      });
    }

    return Promise.resolve({
      success: true,
      message: 'OK',
    });
  }
}
